import {useEffect, useLayoutEffect, useMemo, useState, useRef} from 'preact/hooks';
import classNames from 'classnames';
import {Swiper, SwiperSlide} from 'swiper/react';
import _ from 'lodash';

import {useQfScroll, useQfScreen} from '../comp/utils/hook';
import {appBuilder, scene} from '~/locals/qianfan/index';
import arrow from 'assets/qianfan/icon_play_hover.svg';
import shadowLeft from 'assets/qianfan/swiper-shadow-left.png';
import shadowRight from 'assets/qianfan/swiper-shadow-right.png';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';

const id = 'appBuilder';
const moduleTitleClassName = 'qf-module-title';
const moduleDescClassName = 'qf-module-desc';
const moduleContentClassName = 'qf-module-content';
export const CommonCard = props => {
    const {list, id, screenWidth} = props.data;
    return (
        <div className={`flex-wrapper ${moduleContentClassName}`}>
            {list.map((item, index) => {
                const {id, name, exp, btn, icon} = item;
                return (
                    <div className={`flex-card flex-card${index + 1}`} key={id}>
                        <div className="flex-card-header">
                            <img src={icon} alt="icon" />
                            <h4>{name}</h4>
                        </div>
                        <div className="flex-card-body">
                            {exp.map(it => {
                                return (
                                    <div className="exp" key={it.tit}>
                                        <span className="tit">{it.tit}</span>
                                        {/* eslint-disable-next-line max-len */}
                                        <span className="desc desc_pc no_rem_fs_16">{it.desc}</span>
                                        <span className="desc desc_mobile">{it.desc_m || it.desc}</span>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="flex-card-footer">
                            {btn.map((it, i) => {
                                return (
                                    // eslint-disable-next-line max-len
                                    <a
                                        href={it.link}
                                        key={it.text}
                                        {...it.trackInfo}
                                        target="_blank"
                                        className="btn"
                                        rel="noreferrer"
                                    >
                                        {it.text}
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

const SliderCard = props => {
    const [swiperData, setSwiperData] = useState({});
    const {title, slidesPerView, isMobile, list, spaceBetween, dir} = props.data;
    const swiperRef = useRef();

    const swiperConfig = {
        initialSlide: -2,
        direction: 'horizontal',
        slidesPerView,
        loop: true,
        speed: 6000,
        dir,
        centeredSlides: true,
        spaceBetween,
        autoplay: {
            delay: 0,
            disableOnInteraction: false // 用户操作后是否停止自动播放，默认为true，设为false则不会停止
            // reverseDirection: true
        }
    };

    const handleMouseenter = () => {
        // 存放鼠标悬浮时的transform属性（行内属性）
        let nextTransForm = '';
        // 轮播图从暂停位置移动到原本应到的位置所用的时间
        let nextTime = 0;
        if (swiperRef.current && swiperRef.current.swiper.autoplay) {
            const swiperDom = swiperRef.current.swiper.el.children[0];
            // 轮播图原本应移动到的位置
            nextTransForm = swiperDom.style.transform;
            let nextTransPosition = parseInt(swiperDom.style.transform.split('translate3d(')[1].split('px')[0], 10);
            // 鼠标悬浮时时轮播图位置
            const nowTransPosition = swiperRef.current.swiper.getTranslate();
            // 计算轮播图从暂停位置移动到原本应到的位置所用的时间
            const swiperSlideWidth = swiperDom.children[0].getBoundingClientRect().width;
            nextTime = 6000 * (Math.abs(Math.abs(nextTransPosition) - Math.abs(nowTransPosition)) / swiperSlideWidth);
            setSwiperData({nextTransForm, nextTime});
            const instance = swiperRef.current.swiper.getTranslate();
            swiperRef.current.swiper.setTranslate(instance);
            swiperRef.current.swiper.autoplay.stop();
        }
    };
    const handleMouseleave = () => {
        const {nextTransForm, nextTime} = swiperData;
        if (swiperRef.current && swiperRef.current.swiper.autoplay) {
            const swiperDom = swiperRef.current.swiper.el.children[0];
            swiperDom.style.transform = nextTransForm;
            swiperDom.style.transitionDuration = nextTime + 'ms';
            swiperRef.current.swiper.autoplay.start();
        }
    };

    return (
        <>
            <div className="gradual-title-wrapper">
                <div className="gradual-line gradual-left-line"></div>
                <div className="gradual-title-text no_rem_fs_16">{title}</div>
                <div className="gradual-line gradual-right-line"></div>
            </div>
            <div className="appbuilder-swiper-wrapper">
                <div className="swiper-shadow swiper-shadow-left">
                    <img src={shadowLeft} alt="遮罩" className="shadow-img" />
                </div>
                <Swiper {...swiperConfig} ref={swiperRef}>
                    {list.map((item, index) => {
                        const {icon, text, btn} = item;
                        return (
                            /* eslint-disable */
                            <SwiperSlide key={index} onMouseEnter={handleMouseenter} onMouseLeave={handleMouseleave}>
                                <div className="scene-item">
                                    <a
                                        className="scene-item-content"
                                        target="_blank"
                                        rel="noreferrer"
                                        href={btn.link}
                                        onClick={() => {
                                            setTimeout(() => {
                                                handleMouseleave();
                                            }, 100);
                                        }}
                                        {...btn.trackInfo}
                                    >
                                        <span className="scene-item-icon">
                                            <img src={icon} alt="头像" />
                                        </span>
                                        <span className="scene-item-text no_rem_fs_16">{text}</span>
                                    </a>
                                    <span className="scene-item-btn">
                                        <a href={btn.link} target="_blank" rel="noreferrer" {...btn.trackInfo}>
                                            {btn.text}
                                        </a>
                                    </span>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
                <div className="swiper-shadow swiper-shadow-right">
                    <img src={shadowRight} alt="遮罩" className="shadow-img" />
                </div>
            </div>
        </>
    );
};
const AppBuilder = () => {
    const {list, title, title_m, desc, descLink} = appBuilder;
    const [perView, setPerView] = useState({t: 12, b: 8});
    const [spaceBetween, setSpaceBetween] = useState(20);

    const {showElement, handleScroll, isMobile} = useQfScroll(id);
    const {screenWidth} = useQfScreen();

    useCptDuration(id, {
        name: `${applicationName}-${title}-停留时长`
    });

    useLayoutEffect(() => {
        var width = screenWidth;
        if (width > 1199) {
            setPerView({t: 12, b: 8});
        } else if (width > 993 && width < 1200) {
            setPerView({t: 10, b: 8});
        } else if (width > 769 && width < 992) {
            setPerView({t: 8, b: 6});
        } else if (width > 599 && width < 768) {
            setPerView({t: 6, b: 4});
        } else {
            setPerView({t: 5, b: 5});
        }

        if (screenWidth < 600) {
            setSpaceBetween(6);
        } else {
            setSpaceBetween(20);
        }
    }, [screenWidth]);

    return (
        <div className="app-builder" id={id}>
            <div className="module-wrapper">
                <div className="module-container">
                    <div className="bg"></div>
                    <div className="module-content">
                        <h2 className={`title ${moduleTitleClassName}`}>{screenWidth > 599 ? title : title_m}</h2>
                        <p className={`module-desc no_rem_fs_16 ${moduleDescClassName}`}>
                            <span>{desc}</span>
                            <br className="wrap" />
                            <a
                                href={descLink.link}
                                target="_blank"
                                className="module-desc-link no_rem_fs_16"
                                rel="noreferrer"
                                {...descLink.trackInfo}
                            >
                                <span>{descLink.text}</span>
                                <span className="qf-icon no_rem_qf-icon"></span>
                            </a>
                        </p>
                        <CommonCard data={{list, id, screenWidth}} />
                    </div>
                </div>
            </div>
            <div className={`train-scene ${moduleContentClassName}`}>
                <div className="apply">
                    <SliderCard
                        data={{
                            title: '应用',
                            slidesPerView: perView.t || 12,
                            isMobile,
                            spaceBetween,
                            list: scene.application,
                            dir: 'rtl'
                        }}
                        key="app"
                    />
                </div>
                <div className="assembly">
                    <SliderCard
                        data={{
                            title: '组件',
                            slidesPerView: perView.b || 8,
                            isMobile,
                            spaceBetween,
                            list: scene.assembly,
                            dir: 'ltr'
                        }}
                        key="com"
                    />
                </div>
            </div>
        </div>
    );
};

export default AppBuilder;
